/**
 * Unified place search API.
 * Picks provider based on credentials; for now uses Nominatim only.
 */

import { searchPlaces as nominatimSearch } from '../../osm/places/nominatimPlacesService';

/**
 * Search for places or addresses.
 * Uses Nominatim when Google Places is not configured.
 *
 * @param {string} query - Search query (min 2 chars)
 * @param {Object} [options]
 * @param {number} [options.limit=6]
 * @param {string} [options.lang='original']
 * @param {string[]} [options.countryCodes]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<Array>} Array of { label, display_name, subtitle, lat, lon, ... }
 */
export async function searchPlaces(query, options = {}) {
  // TODO: if (hasGooglePlacesKey()) return googlePlacesService.searchPlaces(...)
  return nominatimSearch(query, options);
}
